import { useState } from "react";
import {
  Stack,
  Typography,
  Divider,
  useTheme,
  IconButton,
  Collapse,
} from "@mui/material";
import { Icon } from "@iconify/react";

import { RHFCheckbox } from "@app/components";
import { Strings } from "@app/constants";

const ColorFilter = ({ color }: any) => {
  const theme = useTheme();
  const [drawerOpen, setDrawerOpen] = useState(true);
  return (
    <Stack sx={{ py: 1 }}>
      <Stack
        flexDirection={"row"}
        justifyContent={"space-between"}
        onClick={() => setDrawerOpen(!drawerOpen)}
      >
        <Typography variant="subtitle1">{Strings.filters.color}</Typography>
        <IconButton size="small">
          {drawerOpen ? (
            <Icon icon="mdi:chevron-up" width={20} height={20} />
          ) : (
            <Icon icon="mdi:chevron-down" width={20} height={20} />
          )}
        </IconButton>
      </Stack>
      <Collapse in={drawerOpen}>
        {color?.map((item: any) => (
          <>
            <RHFCheckbox
              key={item?.id}
              name="color"
              value={item?.id}
              label={item?.name}
              sx={{ "&.Mui-checked": { color: theme.palette.primary.main } }}
            />
            <Divider />
          </>
        ))}
      </Collapse>
    </Stack>
  );
};

export { ColorFilter };
